import { fiveMinutes } from 'queries/constants';
import { dashboardQueryKeys } from 'queries/queryKeys/dashboardKeys';
import { useQuery } from 'react-query';
import { GetPluginDashboard } from 'services/PluginService';

export const useOobDashboard = (pluginId: string, configId: string, workspaceId: string, dashboardPath: string) => {
    return useQuery(
        dashboardQueryKeys.oobDashboard(configId!, dashboardPath!),
        async () => {
            const { dashboard, scopes, variables } = await GetPluginDashboard(
                pluginId!,
                configId!,
                workspaceId!,
                dashboardPath!
            );

            return {
                dashboard,
                scopes,
                variables: variables.map((v) => ({
                    ...v,
                    selectedObjects: [],
                    scope: scopes.find((s) => s.id === v.scope) || { scope: '', workspace: '' }
                }))
            };
        },
        {
            enabled: Boolean(pluginId && dashboardPath),
            staleTime: fiveMinutes,
            cacheTime: fiveMinutes,
            keepPreviousData: true,
            refetchInterval: fiveMinutes
        }
    );
};
